// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.border-color-error {
  border-color: var(--color-error) !important;
}
.forms-method-payment-wrapper {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-small);
  padding-right: 0 !important;
  padding-left: 0 !important;
}
.forms-method-payment-wrapper .vert-col {
  padding-right: 0 !important;
  padding-left: 0 !important;
}
.forms-method-payment-wrapper .vert-row {
  display: flex;
  gap: var(--spacing-small);
  margin-right: 0 !important;
  margin-left: 0 !important;
}
.forms-method-payment-wrapper .vert-row input {
  flex: 1;
  margin-right: 0 !important;
  margin-left: 0 !important;
}
.forms-method-payment-wrapper .vert-row .vert-input:focus {
  border-color: var(--color-highlight-lighter) !important;
}
.forms-method-payment-wrapper .vert-row .vert-select {
  flex: 1.1;
}
.forms-method-payment-wrapper .vert-row .vert-select .ant-select-selector .ant-select-selection-item {
  font-weight: 500;
}
.forms-method-payment-wrapper .vert-row .vert-select .ant-select-selector .ant-select-selection-placeholder {
  font-size: var(--font-paragraph);
  color: var(--color-neutral-dark-lighter);
}
.forms-method-payment-wrapper .vert-row .vert-select .ant-select-arrow {
  font-size: var(--font-paragraph);
  color: var(--color-neutral-dark-lighter);
}
.forms-method-payment-wrapper .formContent {
  display: flex;
  gap: var(--spacing-small);
  width: 100%;
  flex-wrap: wrap;
}
.forms-method-payment-wrapper .formItem {
  display: flex;
  gap: var(--spacing-small);
  width: 100%;
}
@media screen and (max-width: 768px) {
  .forms-method-payment-wrapper .formItem {
    flex-wrap: wrap;
  }
}
.forms-method-payment-wrapper .formItem .formItem-areaCode {
  width: 50% !important;
  max-width: 150px;
}
.forms-method-payment-wrapper .formItem .ant-form-item {
  margin-bottom: 18px;
}
.forms-method-payment-wrapper .formItem .ant-form-item.vert-form-item {
  width: 100%;
}
.forms-method-payment-wrapper .formItem .ant-form-item .ant-form-item-explain .ant-form-item-explain-error {
  color: var(--color-error);
  font-size: var(--font-small);
  font-weight: 500;
}
.forms-method-payment-wrapper .formItem .vert-select.ant-select-single {
  height: unset !important;
}
.forms-method-payment-wrapper .vert-radio.ant-radio-wrapper {
  align-items: center;
  gap: 8px;
  text-align: center;
  font-size: var(--font-paragraph);
}
.forms-method-payment-wrapper .vert-radio.ant-radio-wrapper .ant-radio + span {
  margin-top: unset !important;
  height: unset !important;
}
.forms-method-payment-wrapper .vert-radio.ant-radio-wrapper .ant-radio .ant-radio-inner {
  width: 16px;
  height: 16px;
  border-width: var(--border-width);
}
.forms-method-payment-wrapper .readonly {
  cursor: text;
  pointer-events: none;
}
.forms-method-payment-wrapper .phoneContainer {
  flex-wrap: unset;
}
@media screen and (max-width: 768px) {
  .forms-method-payment-wrapper .vert-row {
    flex-direction: column;
  }
  .forms-method-payment-wrapper .vert-row input {
    min-height: 48px;
  }
  .forms-method-payment-wrapper .phoneContainer {
    flex-wrap: wrap;
  }
  .forms-method-payment-wrapper .phoneContainer .ant-form-item {
    flex: 2;
  }
  .forms-method-payment-wrapper .phoneContainer .formItem-areaCode {
    max-width: 70px;
  }
}
.vert-checkbox-address {
  margin: var(--spacing-small) 0;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/Forms/FormsStyles.less"],"names":[],"mappings":"AAAA;EACE,2CAAA;AACF;AAEA;EACE,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,2BAAA;EACA,0BAAA;AAAF;AALA;EAQI,2BAAA;EACA,0BAAA;AAAJ;AATA;EAYI,aAAA;EACA,yBAAA;EACA,0BAAA;EACA,yBAAA;AAAJ;AAfA;EAkBM,OAAA;EACA,0BAAA;EACA,yBAAA;AAAN;AApBA;EAwBM,uDAAA;AADN;AAvBA;EA4BM,SAAA;AAFN;AA1BA;EA+BU,gBAAA;AAFV;AA7BA;EAmCU,gCAAA;EACA,wCAAA;AAHV;AAjCA;EAwCQ,gCAAA;EACA,wCAAA;AAJR;AArCA;EA+CI,aAAA;EACA,yBAAA;EACA,WAAA;EACA,eAAA;AAPJ;AA3CA;EAsDI,aAAA;EACA,yBAAA;EACA,WAAA;AARJ;AASI;EAAA;IACE,eAAA;EANJ;AACF;AArDA;EA6DM,qBAAA;EACA,gBAAA;AALN;AAzDA;EAiEM,mBAAA;AALN;AAOM;EACE,WAAA;AALR;AA/DA;EAwEQ,yBAAA;EACA,4BAAA;EACA,gBAAA;AANR;AApEA;EA+EM,wBAAA;AARN;AAvEA;EAmFI,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,gCAAA;AATJ;AA7EA;EAyFQ,4BAAA;EACA,wBAAA;AATR;AAjFA;EA6FQ,WAAA;EACA,YAAA;EACA,iCAAA;AATR;AAtFA;EAqGI,YAAA;EACA,oBAAA;AAZJ;AA1FA;EA0GI,gBAAA;AAbJ;AAgBA;EACE;IAEI,sBAAA;EAfJ;EAaA;IAKM,gBAAA;EAfN;EAUA;IAUI,eAAA;EAjBJ;EAOA;IAYM,OAAA;EAhBN;EAIA;IAeM,eAAA;EAhBN;AACF;AAoBA;EACE,8BAAA;EACA,mBAAA;AAlBF","sourcesContent":[".border-color-error {\n  border-color: var(--color-error) !important;\n}\n\n.forms-method-payment-wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-small);\n  padding-right: 0 !important;\n  padding-left: 0 !important;\n\n  .vert-col {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .vert-row {\n    display: flex;\n    gap: var(--spacing-small);\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n\n    input {\n      flex: 1;\n      margin-right: 0 !important;\n      margin-left: 0 !important;\n    }\n\n    .vert-input:focus {\n      border-color: var(--color-highlight-lighter) !important;\n    }\n\n    .vert-select {\n      flex: 1.1;\n      .ant-select-selector {\n        .ant-select-selection-item {\n          font-weight: 500;\n        }\n\n        .ant-select-selection-placeholder {\n          font-size: var(--font-paragraph);\n          color: var(--color-neutral-dark-lighter);\n        }\n      }\n      .ant-select-arrow {\n        font-size: var(--font-paragraph);\n        color: var(--color-neutral-dark-lighter);\n      }\n    }\n  }\n\n  .formContent {\n    display: flex;\n    gap: var(--spacing-small);\n    width: 100%;\n    flex-wrap: wrap;\n  }\n\n  .formItem {\n    display: flex;\n    gap: var(--spacing-small);\n    width: 100%;\n    @media screen and (max-width: 768px) {\n      flex-wrap: wrap;\n    }\n    .formItem-areaCode {\n      width: 50% !important;\n      max-width: 150px;\n    }\n    .ant-form-item {\n      margin-bottom: 18px;\n\n      &.vert-form-item {\n        width: 100%;\n      }\n\n      .ant-form-item-explain .ant-form-item-explain-error {\n        color: var(--color-error);\n        font-size: var(--font-small);\n        font-weight: 500;\n      }\n    }\n\n    .vert-select.ant-select-single {\n      height: unset !important;\n    }\n  }\n  .vert-radio.ant-radio-wrapper {\n    align-items: center;\n    gap: 8px;\n    text-align: center;\n    font-size: var(--font-paragraph);\n    .ant-radio {\n      + span {\n        margin-top: unset !important;\n        height: unset !important;\n      }\n      .ant-radio-inner {\n        width: 16px;\n        height: 16px;\n        border-width: var(--border-width);\n      }\n    }\n  }\n\n  .readonly {\n    cursor: text;\n    pointer-events: none;\n  }\n\n  .phoneContainer {\n    flex-wrap: unset;\n  }\n}\n@media screen and (max-width: 768px) {\n  .forms-method-payment-wrapper {\n    .vert-row {\n      flex-direction: column;\n\n      input {\n        min-height: 48px;\n      }\n    }\n\n    .phoneContainer {\n      flex-wrap: wrap;\n      .ant-form-item {\n        flex: 2;\n      }\n      .formItem-areaCode {\n        max-width: 70px;\n      }\n    }\n  }\n}\n.vert-checkbox-address {\n  margin: var(--spacing-small) 0;\n  white-space: nowrap;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
